import { client } from "@/api/request";
import SalesReport from "../usecases/sales-report";

export interface GetSalesReportQuery {
  month: string; // yyyy-MM
  projectId?: string;
  monthOptions?: string;
  companyId?: string;
  companyType?: string;
  vendorId?: string;
  staffId?: string;
}

export interface GetProjectSalesReportQuery {
  month: string; // yyyy-MM
  monthOptions?: string;
  vendorId?: string;
  projectId?: string;
}

export interface GetAllProjectSalesReportQuery {
  month: string | string[]; // yyyy-MM
  monthOptions?: string;
  companyType?: string;
  clientId?: string;
  staffId?: string;
  vendorId?: string;
  expenseCategoryId?: string;
  projectId?: string;
  constructionTypeId?: string;
  initMonth?: string;
}

export interface GetServiceProjectCompaniesQuery {
  type: string;
  companyType?: string;
}

export interface GetProductSummaryQuery {
  projectId?: string;
}

/**
 * 請求レポートを取得する
 */
export function getSalesReport(
  query: GetSalesReportQuery
): Promise<SalesReport> {
  const res = client.get("get_sales_report.php", query);
  return res;
}

export function getProjectSalesReport(
  query: GetProjectSalesReportQuery
): Promise<any> {
  const res = client.get("get_project_sales_report.php", query);
  return res;
}

export function getSalesReportCSV(
  query: GetAllProjectSalesReportQuery)
  : Promise<any> {
  const res = client.get("get_sales_report_csv.php", query);
  return res;
}

export function getProjectSummary(query: GetProductSummaryQuery): Promise<any> {
  const res = client.get("get_project_summary.php", query);
  return res;
}

export function getProjectMonths(query: GetProductSummaryQuery): Promise<any> {
  const res = client.get("get_project_months.php", query);
  return res;
}

export function getAllProjectSalesReport(
  query: GetAllProjectSalesReportQuery
): Promise<any> {
  const res = client.get("get_all_project_sales_report.php", query);
  return res;
}

export async function getPresets(): Promise<any> {
  const res = await client.get("get_presets.php");
  return res;
}

export async function savePreset(data: FormData): Promise<any> {
  const res = await client.post("save_preset.php", data);
  return res;
}

export async function deletePreset(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);
  const res = await client.post("delete_preset.php", data);
  return res;
}

export function getServiceProjectCompanies(
  query: GetServiceProjectCompaniesQuery
): Promise<any> {
  const res = client.get("get_service_project_companies.php", query);
  return res;
}

export function getServiceProjectResponsibleStaffs(): Promise<any> {
  const res = client.get("get_service_project_responsible_staffs.php");
  return res;
}
